import r from "./ghl-ui.es1194.js";
var a = /^\s+/;
function t(e) {
  return e && e.slice(0, r(e) + 1).replace(a, "");
}
export {
  t as default
};
